import { Divider } from "@mui/material";
import CSDelete from "./components/CSDelete";
import CSInputs from "./components/CSInputs";
import CSSwitches from "./components/CSSwitches";
import CSColors from "./components/CSColors";
import CSSlider from "./components/CSSlider";
import CSAlignment from "./components/CSAlignment";

function ComponentSettings({
  components,
  handleComponentAttribute,
  deleteComponent,
  addImage,
  setComponents,
  selectedComponentIndex,
  selectedLanguage,
  attributes
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <h3 style={{ textAlign: "center", margin: "0" }}>
        {components[selectedComponentIndex]?.label}
      </h3>

      <Divider />

      <CSDelete deleteComponent={deleteComponent} />

      <Divider />

      <CSInputs
        components={components}
        changeRetries={handleComponentAttribute}
        addImage={addImage}
        setComponents={setComponents}
        selectedLanguage={selectedLanguage}
        selectedComponentIndex={selectedComponentIndex}
        attributes={attributes}
        changeSlotCount={handleComponentAttribute}
        changeUrlInput={attributes}
        changeRecipient={handleComponentAttribute}
        changeSubject={handleComponentAttribute}
        changeBodyText={handleComponentAttribute}

      />
      <CSSwitches
        components={components}
        handleSwitch={handleComponentAttribute}
        selectedComponentIndex={selectedComponentIndex}
      />

      <Divider />

      <CSColors
        components={components}
        changeColor={handleComponentAttribute}
        selectedComponentIndex={selectedComponentIndex}
      />

      <CSSlider
        components={components}
        handleSlide={handleComponentAttribute}
        selectedComponentIndex={selectedComponentIndex}
      />

      <CSAlignment
        components={components}
        handleAlignment={handleComponentAttribute}
        selectedComponentIndex={selectedComponentIndex}
      />
    </div>
  );
}

export default ComponentSettings;